/**
 * Method due to replace multiple substrings, with different values, in one string.
 */
export function replaceAllInString(replacers, originalElement) {
  var replacedString = originalElement;
  for (var replacer in replacers) {
    replacedString = replacedString.replace(new RegExp(replacer, 'g'), replacers[replacer]);
  }
  return replacedString;
};
/**
 * function extracted from GTM.
 */
export function isAHWebSite(url) {
  var r = false;
  if (url && typeof(url) == 'string' && url.length > 0) {
    var re = new RegExp(/\.accor\.com/);
    r = re.test(url);
  }
  return r;
};


/**
 * function generate guid
 */
export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
